import { AxiosResponse } from "axios";

import { ShowWithComedian } from "@punchup/data/legacy/shows";
import { VenuePagesRow } from "@punchup/venues/data/venue_pages";
import { useMutation, UseMutateFunction } from "@tanstack/react-query";
import { useTixologi } from "@punchup/data/legacy/hooks";
import { deleteTixologiEvent } from "./deleteTixologiEvent";

type UseDeleteEventReturn = {
  mutate: UseMutateFunction<AxiosResponse, Error, void, unknown>;
  isPending: boolean;
  isSuccess: boolean;
  error: Error | null;
};

export function useDeleteEvent({
  show,
  venuePage,
}: {
  show: ShowWithComedian;
  venuePage: VenuePagesRow;
}): UseDeleteEventReturn {
  const { tixologiData } = useTixologi({ id: venuePage.id, isComedian: false });

  const { mutate, isPending, isSuccess, error } = useMutation({
    mutationFn: () =>
      deleteTixologiEvent(show.tixologi_event_id, tixologiData?.token),
  });
  return { mutate, isPending, isSuccess, error };
}
